import React from 'react'

import styled from '@emotion/styled'
import { text, black03 } from '../../../_style'
import { Link } from 'gatsby';

const Container = styled(Link)`
  display: inline-block;
  font-size: 14px;
  line-height: 1;
  svg {
    display: inline-block;
    width: 5px;
    height: 9px;
    margin-right: 21px;
  }
`
export default class BackToLineupBtn extends React.Component {
  render() {
    return(
      <Container to={'/lineup'}>
        <svg xmlns="http://www.w3.org/2000/svg" width="4.407" height="8.44" viewBox="0 0 4.407 8.44">
          <path d="M4.907 8.22l-4-4 4-4" fill="none" stroke="#00ab84"/>
        </svg>
        <span>一覧へ戻る</span>
      </Container>
    )
  }
}
